export const getSpaUrlForClassicSettings = (
	subroute: string,
	projectKey: string,
	optionalParams?: string,
) => `/jira/servicedesk/projects/${projectKey}/settings/${subroute}${optionalParams || ''}`;
